import React from 'react';
import { useSelector } from 'react-redux';

export default function PercentageChange({ symbolId }) {
    const symbol = useSelector(state => state.updateSymbol.symbols?.[symbolId])

    if (!symbol || !symbol.open) return <span>--</span>;

    const percentageChange = ((symbol.bid - symbol.close) / symbol.close * 100).toFixed(2);
    // const color = percentageChange < 0 ? "#da5244" : "#3687ed";

    return <span className={`${percentageChange > 0 ? 'green' : 'red'} `}>{percentageChange}%</span>;
}
